import React from 'react';
import './AppStoreButton.css';

const AppStoreButton = () => {
  return (
    <a 
      href="https://apps.apple.com/am/app/hanzi-flashcards-3d/id6742253344" 
      target="_blank" 
      rel="noopener noreferrer"
      className="app-store-button"
    >
      <img 
        src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83"
        alt="Download on the App Store"
        className="app-store-badge"
      />
    </a>
  );
};

export default AppStoreButton; 